<h3>{{ data.organizationName }}</h3>
<ham-button class="add-btn" (buttonClick)="onAddPackage()" icon="assets/hamIcons/plus-outline.svg">{{
    'aumico_admin_organization_list_add_package' | i18next
}}</ham-button>
<ham-table [dataSource]="data.packages" [pageSize]="10">
    <!-- Header Definitions -->
    <ng-template hamHeaderCell hamTextCol>{{ 'aumico_admin_organization_list_package_type' | i18next }} </ng-template>
    <ng-template hamHeaderCell hamDateCol>
        {{ 'aumico_admin_organization_list_package_start_date' | i18next }}</ng-template
    >
    <ng-template hamHeaderCell hamDateCol
        >{{ 'aumico_admin_organization_list_package_end_date' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_admin_organization_list_package_size' | i18next }}
    </ng-template>

    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_admin_organization_list_actions' | i18next }}
    </ng-template>

    <!-- Cell Definitions -->

    <ng-template hamCell let-element hamTextCol> {{ element?.type || '-' }} </ng-template>
    <ng-template hamCell let-element hamDateCol> {{ (element?.startDate | dateLocale) || '-' }} </ng-template>
    <ng-template hamCell let-element hamDateCol>
        {{ (element?.endDate | dateLocale) || '-' }}
    </ng-template>
    <ng-template hamCell let-element hamTextCol>
        {{ element?.packageSize || '-' }}
    </ng-template>
    <ng-template hamCell let-element hamTextCol>
        <div class="d-flex gap-2">
            <span
                hamIconShapes
                icon="assets/hamIcons/trash-outline.svg"
                variant="red"
                (click)="onDeletePackage(element.packageId)"
            >
            </span>
            <span hamIconShapes icon="assets/hamIcons/pen-outline.svg" outline="true" (click)="onEditPackage(element)">
            </span>
        </div>
    </ng-template>
</ham-table>
<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDeleteModal"
    (cancel)="showDeleteModal = false"
    (action)="onConfirmDelete()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_admin_delete_package_confirmation_dialog_description' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
